<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/product/02/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="page-content-child"
                v-for="(src,i) of imgArr"
                :key="i"
            >
                <div class="content-w">
                    <img :src="src" width="100%" alt="" />
                </div>
            </div>
            <div class="z-n-y-j-z-c page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="z-n-y-j-z-c-content">
                            <auto-row class="max-size list flex-column">
                                <auto-col class="list-item" v-for="(item,index) of z_n_y_j_z_c_list.slice(0,2)" :key="index">
                                    <div class="title">{{item.title}}</div>
                                    <div class="info flex-items-center">
                                        <img :src="item.icon" class="img max-size" alt="">
                                        <p class="text">{{item.content}}</p>
                                    </div>
                                </auto-col>
                            </auto-row>
                            <auto-row class="max-size list-more flex-column">
                                <auto-col class="list-item-more" v-for="(item,index) of z_n_y_j_z_c_list.slice(2)" :key="index">
                                    <div class="title">{{item.title}}</div>
                                    <div class="list-icons flex">
                                        <auto-row class="list-item-icons" v-for="(cell,index2) of item.list" :key="index2">
                                            <auto-col class="icon-info">
                                                <div style="margin: auto">
                                                    <img :src="cell.icon" class="icon"  alt="">
                                                </div>
                                                <div class="text">{{cell.label}}</div>
                                            </auto-col>
                                        </auto-row>
                                    </div>

                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/product/02/pic-1.png'),
                    // require('@/assets/image/product/02/pic-2.png'),
                ],
                z_n_y_j_z_c_list:[
                    {
                        title:'安防套装设备',
                        icon:require('@/assets/image/product/02/anfang.png'),
                        content:'主机、红外探测器、门窗感应器 、SOS报警器'
                    },
                    {
                        title:'居家照护设备',
                        icon:require('@/assets/image/product/02/jujia.png'),
                        content:'终端主机、红外线感应器、SOS紧急报警按钮 、携带式SOS报警遥控器 、 SOS紧急报警按钮(7件套) 、烟雾报警器(7件套) 、煤气报警器(7件套)'
                    },
                    {
                        title:'机构运营设备',
                        list:[
                            {label:"移动终端L2", icon:require('@/assets/image/product/02/3-1.png')},
                            {label:"远程智护睡眠检测带", icon:require('@/assets/image/product/02/3-2.png')},
                            {label:"远程智护医疗血压计", icon:require('@/assets/image/product/02/3-3.png')},
                            {label:"心冲击图智能枕", icon:require('@/assets/image/product/02/3-4.png')},
                            {label:"跌倒报警雷", icon:require('@/assets/image/product/02/3-5.png')},
                            {label:"人流量监控", icon:require('@/assets/image/product/02/3-6.png')},
                            {label:"网络摄像", icon:require('@/assets/image/product/02/3-7.png')},
                            {label:"照护手环", icon:require('@/assets/image/product/02/3-8.png')},
                        ],
                    },
                    {
                        title:'居家类设备',
                        list:[
                            {label:"智能照护手环", icon:require('@/assets/image/product/02/jujialei-1.png')},
                            {label:"全屋雷达设备", icon:require('@/assets/image/product/02/jujialei-2.png')},
                            {label:"智能水表", icon:require('@/assets/image/product/02/jujialei-3.png')},
                            {label:"智能电表", icon:require('@/assets/image/product/02/jujialei-4.png')},
                            {label:"智能机器人", icon:require('@/assets/image/product/02/jujialei-5.png')},
                            {label:"智能摄像机", icon:require('@/assets/image/product/02/jujialei-6.png')},
                            {label:"远程智护睡眠检测带", icon:require('@/assets/image/product/02/jujialei-7.png')},
                            {label:"心冲击图智能枕", icon:require('@/assets/image/product/02/jujialei-18.png')},
                        ],
                    },
                    {
                        title:'智慧养老院设备',
                        list:[
                            {label:"健康智能床", icon:require('@/assets/image/product/02/zhyly-1.png')},
                            {label:"心冲击图智能枕", icon:require('@/assets/image/product/02/zhyly-2.png')},
                            {label:"健康码扫码盒", icon:require('@/assets/image/product/02/zhyly-3.png')},
                            {label:"额温枪", icon:require('@/assets/image/product/02/zhyly-4.png')},

                            {label:"床位智能平板", icon:require('@/assets/image/product/02/zhyly-5.png')},
                            {label:"识别测温手环", icon:require('@/assets/image/product/02/zhyly-6.png')},

                            {label:"血压计", icon:require('@/assets/image/product/02/zhyly-7.png')},
                            {label:"感应冲水器", icon:require('@/assets/image/product/02/zhyly-8.png')},
                            {label:"远程智护睡眠检测带", icon:require('@/assets/image/product/02/zhyly-9.png')},
                            {label:"照护手环", icon:require('@/assets/image/product/02/zhyly-10.png')},
                        ],
                    },
                    {
                        title:'社区设备',
                        list:[
                            {label:"一体化触摸屏", icon:require('@/assets/image/product/02/shequ-1.png')},
                            {label:"人脸识别测温一体机", icon:require('@/assets/image/product/02/shequ-2.png')},
                            {label:"身高体重一体机", icon:require('@/assets/image/product/02/shequ-3.png')},
                            {label:"健康检测仪", icon:require('@/assets/image/product/02/shequ-4.png')},

                            {label:"远程问诊机", icon:require('@/assets/image/product/02/shequ-5.png')},
                            {label:"血压计", icon:require('@/assets/image/product/02/shequ-6.png')},

                            {label:"人流量监控", icon:require('@/assets/image/product/02/shequ-7.png')},
                            {label:"网络摄像", icon:require('@/assets/image/product/02/shequ-8.png')},
                            {label:"跌倒雷达", icon:require('@/assets/image/product/02/shequ-9.png')},
                        ],
                    }
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        /*padding-bottom:132px;*/
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(n){
        background-color:#ffffff;
    }
    .page-content-box{
        overflow:hidden;
        min-height:500px;
    }
    .z-n-y-j-z-c .z-n-y-j-z-c-content{
        margin-top:5px;
    }

    .z-n-y-j-z-c .z-n-y-j-z-c-content .list .list-item{
        margin-bottom:88px;
        transition: all .3s;
    }
    .z-n-y-j-z-c .z-n-y-j-z-c-content .list .list-item:hover{
        transform: translateY(-5px);
    }
    .z-n-y-j-z-c .list .list-item .title{
        font-size: 24px;
        font-weight: bold;
        color: #FFFFFF;
        padding: 12px 0;
        width: 100%;
        background: #2FA8D0;
        height: 7vw;
        max-height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .z-n-y-j-z-c .list .info{
        border: 1px solid #2FA8D0;
        padding:22px 82px;
    }

    .z-n-y-j-z-c .list .info .img{
        width: 321px;
        height: 171px;
        vertical-align:middle;
    }

    .z-n-y-j-z-c .list .info .text{
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        margin-left:40px;
    }



    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
        padding-bottom:132px;
    }

    .z-n-y-j-z-c .list-more .list-item-more .title{
        font-size: 24px;
        font-weight: bold;
        color: #FFFFFF;
        padding: 12px 0;
        width: 100%;
        background: #2FA8D0;
        height: 7vw;
        max-height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons{
        text-align: center;
        border: 1px solid #2FA8D0;
        margin-bottom:88px;
    }

    .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
        width:calc(12.5%);
        text-align: center;
        transition: all .3s;
    }

    .icon-info{
        display: flex;
        flex-flow: column nowrap;
        padding:30px 0;
        width:100%;
        transition: all .3s;
    }


    .icon-info:hover{
        transform: translateY(-5px);
        color:#2FA8D0;
    }

    .icon-info .icon{
        margin: 0 auto;
    }

    .icon-info .text{
        padding-top:16px;
    }



    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){

    }

    @media screen and (max-width: 1200px){
        .z-n-y-j-z-c .list .info{
            transition: all .3s;
            padding:22px 62px;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            padding-bottom:80px;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
            width:calc(20%);
            text-align: center;
            transition: all .3s;
        }

        .list-icons{
            display: flex;
            flex-flow: row  wrap;
        }
    }

    @media screen and (max-width: 960px){
        .z-n-y-j-z-c .list .info{
            border: 1px solid #2FA8D0;
            display: flex;
            flex-flow: column  nowrap;
        }

        .z-n-y-j-z-c .list .info .text{
            margin-left:0px;
            margin-top:20px;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            padding-bottom:50px;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
            width:calc(25%);
            text-align: center;
            transition: all .3s;
        }

        .list-icons{
            display: flex;
            flex-flow: row  wrap;
        }

    }

    @media screen and (max-width: 760px){
        .z-n-y-j-z-c .list .info{
            padding:22px 20px;
        }
        .z-n-y-j-z-c .list .info .img{
            width: 100%;
            height: 100%;
            vertical-align:middle;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-more{
            padding-bottom:0px;
        }

        .z-n-y-j-z-c .z-n-y-j-z-c-content .list-icons .list-item-icons{
            width:calc(33.33%);
            text-align: center;
            transition: all .3s;
        }

        .list-icons{
            display: flex;
            flex-flow: row  wrap;
        }

    }
</style>
